<template>
  <div v-loading="loading" class="chart-card">
    <div class="chart-title">
      <span class="bullet purple-bullet"></span>
      KHÔNG GIAN VĂN HÓA THEO DANH MỤC
    </div>
    <div class="chart-container-large">
      <apexchart
        v-if="!loading && donutSeries.length > 0"
        type="donut"
        width="100%"
        height="400"
        :options="donutOptions"
        :series="donutSeries"
      ></apexchart>
      <el-empty v-else-if="!loading" description="Không có dữ liệu"></el-empty>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import { getCategory } from '@/services/category'
import { listPlaces } from '@/services/place'
import { getTranslation } from '@/utils/filters'

export default {
  name: 'DonutChart',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      loading: false,
      donutSeries: [],
      donutOptions: {
        chart: {
          type: 'donut',
          fontFamily: 'inherit'
        },
        labels: [],
        colors: [
          '#8a2be2',
          '#c0392b',
          '#2980b9',
          '#e67e22',
          '#27ae60',
          '#bb8fce',
          '#f1c40f',
          '#1abc9c',
          '#d35400',
          '#2c3e50'
        ],
        legend: {
          show: true,
          position: 'bottom',
          fontSize: '13px',
          fontWeight: 600,
          fontFamily: 'inherit',
          markers: {
            radius: 3
          },
          itemMargin: {
            horizontal: 10,
            vertical: 6
          },
          offsetY: 0,
          formatter(seriesName, opts) {
            return seriesName + ' - ' + opts.w.globals.series[opts.seriesIndex]
          }
        },
        plotOptions: {
          customScale: 0.95,
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#7f8c8d',
                  offsetY: -5
                },
                value: {
                  show: true,
                  fontSize: '32px',
                  fontWeight: 800,
                  color: '#2c3e50',
                  offsetY: 5,
                  formatter(val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Điểm',
                  color: '#7f8c8d',
                  fontSize: '13px',
                  fontWeight: 600,
                  formatter(w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter(val, opts) {
            return opts.w.globals.series[opts.seriesIndex]
          },
          style: {
            fontSize: '13px',
            fontWeight: 700,
            colors: ['#fff']
          },
          dropShadow: {
            enabled: false
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter(val) {
              return `${val} không gian`
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    language() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const categoryResponse = await getCategory(
          {
            place_type: 'attraction',
            page: 1,
            per_page: 100,
            locale: this.language
          },
          'attraction'
        )
        const categories = categoryResponse.result || []
        if (categories.length === 0) {
          this.donutSeries = []
          this.donutOptions = { ...this.donutOptions, labels: [] }
          this.loading = false
          return
        }

        const labels = categories.map((c) => {
          const trans = getTranslation(c, this.language)
          return trans ? trans.name : c.name || ''
        })

        const placesResponse = await listPlaces({
          place_types: 'attraction',
          page: 1,
          per_page: 100,
          locale: this.language
        })
        const places = placesResponse.result || []

        const series = categories.map((c) => {
          return places.filter(place => place.category_id === c.id || (place.category && place.category.id === c.id)).length
        })

        this.donutSeries = series
        this.donutOptions = {
          ...this.donutOptions,
          labels
        }
      } catch (err) {
        console.error('Failed to load Donut Chart data:', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  .chart-title {
    font-size: 13px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    .bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .purple-bullet {
      background-color: #8a2be2;
    }
  }
}

.chart-container-large {
  min-height: 400px;
  width: 100%;
  display: block;
}
</style>
